import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Box,
  Flex,
  Icon,
  Image,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react'
import { useController } from 'react-hook-form'
import { BsChevronDown } from 'react-icons/bs'
import InfoIcon from '@/public/assets/icons/info.svg'

export const VerifyFormSelect = ({
  name,
  label,
  options,
  value,
  placeholder,
  description,
}: {
  name: string
  label?: string
  description?: string
  value?: string
  options: Array<{ label: string; value: string; image?: string }>
  placeholder?: string
}) => {
  const { field, fieldState } = useController({
    name,
    defaultValue: value,
    rules: { required: true },
  })

  const currentOption = options.find((option) => option.value === field.value)

  return (
    <Box mb={3}>
      <Flex alignItems={'center'} justifyContent={'space-between'}>
        {label && (
          <Text mb={1} fontSize={'sm'} fontWeight={700}>
            {label}
          </Text>
        )}
        {!!description && (
          <Popover placement={'top'}>
            <PopoverTrigger>
              <Icon cursor={'pointer'} color={'ninja.200'} as={InfoIcon} />
            </PopoverTrigger>
            <PopoverContent
              bg={'ninja.400'}
              p={2}
              border={'none'}
              rounded={'lg'}
              boxShadow={'0px 4px 32px 0px rgba(0, 0, 0, 0.24);'}
              maxW={'220px'}
              fontSize={'xs'}
              fontWeight={500}
              color={'ninja.100'}
              textAlign={'center'}
            >
              {description}
            </PopoverContent>
          </Popover>
        )}
      </Flex>

      <Menu placement="bottom-end">
        <MenuButton
          textAlign={'left'}
          w={'full'}
          px={4}
          h={'56px'}
          bg={'ninja.500'}
          rounded={'2xl'}
          fontWeight={700}
          fontSize={'sm'}
          _placeholder={{
            color: 'ninja.300',
          }}
          border={'2px solid'}
          borderColor={!!fieldState.error ? 'brand.error' : 'transparent'}
        >
          <Flex w={'full'} alignItems={'center'} gap={2} justifyContent={'space-between'}>
            {currentOption?.label ? (
              <Flex alignItems={'center'} gap={2}>
                {!!currentOption.image && <Image boxSize={8} src={currentOption.image} />}
                <Text>{currentOption.label}</Text>{' '}
              </Flex>
            ) : (
              <Text color={'ninja.200'}>{placeholder}</Text>
            )}
            <Icon color={'ninja.100'} as={BsChevronDown} />
          </Flex>
        </MenuButton>
        <MenuList
          p={2}
          bg={'ninja.500'}
          border={'none'}
          minW={40}
          w={'max-content'}
          rounded={'xl'}
          boxShadow={'0px 8px 48px 0px rgba(0, 0, 0, 0.20)'}
          zIndex={10}
        >
          {options.map((option, index) => (
            <MenuItem
              key={index}
              bg={'transparent'}
              _hover={{
                bg: 'ninja.600',
              }}
              fontWeight={700}
              px={3}
              py={1.5}
              pl={!!option.image ? 2 : 3}
              rounded={'lg'}
              fontSize={'sm'}
              onClick={() => field.onChange(option.value)}
              justifyContent={'start'}
              gap={2}
            >
              {!!option.image && <Image boxSize={8} src={option.image} />}
              <Text>{option.label}</Text>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      {fieldState.error && (
        <Text lineHeight={1.1} px={3} mt={1} fontWeight={700} fontSize={'xs'} color={'brand.error'}>
          {fieldState.error.message}
        </Text>
      )}
    </Box>
  )
}
